import type { BudgetSolution } from "./budgetSolve";
import type { RxTunables } from "./rxInputs";

/*
 *
 * The request itself is clamped at the floor: with a blanket minimum, no critical can average
 * below it, so accepting a lower number would leave the field silently unsatisfiable.
 */
export function budgetTarget(
  next: RxTunables,
  nutrient: "p2o5" | "k2o",
): number {
  const drop = nutrient === "p2o5" ? next.pDropBelowLbAc : next.kDropBelowLbAc;
  // With a drop, cells can legally be 0, so the blanket min is not a floor on the average.
  if (drop != null && drop > 0) return Math.max(next.budgetLbAc ?? 0, 0);
  const minLbAc = nutrient === "p2o5" ? next.pMinLbAc : next.kMinLbAc;
  return Math.max(next.budgetLbAc ?? 0, minLbAc);
}

/* * Write a solved critical back onto the tunables. K keeps the CEC-tier gap. */
export function tunablesAfterBudget(
  next: RxTunables,
  nutrient: "p2o5" | "k2o",
  target: number,
  sol: BudgetSolution,
): RxTunables {
  return nutrient === "p2o5"
    ? { ...next, budgetLbAc: target, pCrit: sol.critical }
    : {
        ...next,
        budgetLbAc: target,
        kCritHighCec: sol.critical,
        kCritLowCec: Math.max(
          0,
          sol.critical - Math.max(0, next.kCritHighCec - next.kCritLowCec),
        ),
      };
}
